export default __webpack_public_path__ + "static/media/ten.e4f58042.jpg";